import Usercentrics from "../Usercentrics/usercentrics";

/**
 * Inline videos, with a custom preview image or video, rendering a video player after clicking "Play".
 * Requirements:
 * - A trigger, usually a button. Must have the following attributes:
 *   - data-js-video-inline - Required for initialization
 *   - data-js-video-inline-target - ID of the associated iframe element
 * - An iframe, must have the following attribute:
 *   - data-js-video-inline-id - ID format does not matter, but associated trigger must refer to the same exact ID
 *   - data-embedded-video-url - The full source to the embeddable video, used to set the iframe src attribute only when applicable
 *    (i.e. when cookies are acceptet)
 * - A cookie consent information modal
 *   - Must have the following attributes:
 *     - data-js-cookie-consent-modal-id - ID format does not matter, but associated trigger must refer to the same exact ID
 *   - Must have a consent button with the following attributes:
 *     - data-js-cookie-consent-button-id - ID format does not matter, but associated trigger must refer to the same exact ID
 */
export const videoInline = () => {
  const videoPlayButtons = document.querySelectorAll("[data-js-video-inline]");

  if (!videoPlayButtons?.length) {
    return;
  }

  for (const playButton of videoPlayButtons) {
    const targetVideoIframe = playButton.getAttribute("data-js-video-inline-target");

    if (!targetVideoIframe?.length) {
      console.warn("Inline video trigger found, but no target iframe ID is set.");
      continue;
    }

    const videoIframe = document.querySelector(
      `[data-js-video-inline-id="${targetVideoIframe}"]`
    ) as HTMLElement;

    if (!videoIframe) {
      console.warn(
        "Inline video trigger with associated iframe ID found, but no actual iframe with the corresponding ID was found."
      );
      continue;
    }

    const cookieModal = document.querySelector(
      `[data-js-cookie-consent-modal-id="${targetVideoIframe}"]`
    ) as HTMLElement | undefined;

    if (!cookieModal) {
      console.warn(
        "Inline video cookie modal trigger with associated iframe ID found, but no actual cookie modal with the corresponding ID was found."
      );
      continue;
    }

    const cookieConsentButton = document.querySelector(
      `[data-js-cookie-consent-button-id="${targetVideoIframe}"]`
    ) as HTMLElement | undefined;

    if (!cookieConsentButton) {
      console.warn(
        `Inline video cookie consent modal with ID ${targetVideoIframe} contains no consent button.`
      );
      continue;
    }

    playButton.addEventListener("click", async (e: Event) => {
      e.preventDefault();
      if (Usercentrics.getDataProcessingConsent("Vimeo")) {
        const videoIframeSrc = videoIframe.dataset.embeddedVideoUrl;
        if (!videoIframeSrc) {
          console.warn("Inline video is missing the embedded video URL attribute.");
          return;
        }

        videoIframe.classList.remove("opacity-0");
        videoIframe.classList.remove("pointer-events-none");
        videoIframe.setAttribute("src", videoIframeSrc);
        return;
      }

      // Inform visitor about required cookies and request consent.
      cookieModal.classList.remove("hidden");
    });

    cookieConsentButton.addEventListener("click", (e: Event) => {
      e.preventDefault();
      Usercentrics.acceptServices(["Vimeo", "YouTube Video"]);
      cookieModal.classList.add("hidden");

      (playButton as HTMLElement).click();
    });
  }
};
